import React from 'react';
import { connect } from 'react-redux';
import "./styles.css";

class Component extends React.Component {

    constructor(props){
        super(props);
    }

    render() {
        return(
            <React.Fragment>
                <div className='teachCard'>
                    <div className='course'>
                        {this.props.course}
                    </div>
                    <div className='job'>
                        {this.props.job}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const Redux = connect(store => ({

}))(Component);

export const TeachingCardComponent = Redux;